import { Link } from "react-router-dom/dist";
import { useLanguage } from "../contexts/LanguageContext";
import { AuthWrapperProps } from "../types/Props"
import { getLogoByLanguage } from "../utils/getLogoByLanguage";

const AuthWrapper = ({ mode, children }: AuthWrapperProps) => {
  const { language, translations } = useLanguage();
  const mainLogoUrl = getLogoByLanguage(language);

  return (
    <div className="auth-container">
      <div className="login-box">
        <div className="card auth-card">
          <img src={mainLogoUrl} className='card-header-logo' alt='Auth Page Logo'></img>
          {children}
        </div>
        { mode === "login" && (
          <>
            <div className="login-separator">
              <strong>------------ {translations.or} ------------</strong>
            </div>
            <Link to="/">
              <div className="card continue-without">
                <span>{translations.continuewithout}</span><br />
                <span className="small-text">{translations.allfeaturesnotavailable}</span>
              </div>
            </Link>
          </>
        )}
      </div>
    </div>
  )
};

export default AuthWrapper;